import { useMemo } from "react";

import PivotTable from "@Components/PivotTable";
import { formatters } from "@Components/hierarchical-report/utils";
import ImpressionStore from "@Modules/report/stores/impression";

import { useImpressionPivotStore, ImpressionPivotProvider } from "./store";

function ImpressionPivotTable() {
  const { data, reportView, loading, useLoad } = useImpressionPivotStore()

  const configure = useMemo(() => ({
    pivotby: {
      default: {
        cols: ['path'],
        rows: ['page'],
        metric: "revenue",
        aggregator: 'sum',
        sort: 'asc',
        formatter: 'money',
      },
      options: {
        dimensions: [
          { value: 'publisher', label: 'Publisher' },
          { value: 'allocation', label: 'Allocation' },
          { value: 'sid1', label: 'SubID 1' },
          { value: 'device', label: 'Device' },
          { value: 'pathUserProfile', label: 'Path User Profile' },
          { value: 'path', label: 'Path' },
          { value: 'slot', label: 'Slot' },
          { value: 'page', label: 'Page' },
          { value: 'pageVersion', label: 'Page Version' },
          { value: 'partner', label: 'Partner' },
          { value: 'hour', label: 'Hour' },
          { value: 'day', label: 'Day' },
          { value: 'month', label: 'Month' },
          { value: 'gender', label: 'Gender' },
          { value: 'action', label: 'Action' },
          { value: 'field', label: 'Field' },
          { value: 'answer', label: 'Answer' },
          { value: 'completed', label: 'Completed' },
          { value: 'pathContainerSlot', label: 'Path Container Slot' },
          { value: 'experimentVersion', label: 'Experiment Version' },
          {
            group: 'Meta Fields',
            options: ImpressionStore.metaField.fetchData,
          },
        ],
        metrics: [
          { value: 'uniqUser', label: 'Users' },
          { value: 'completed', label: 'Page Completed' },
          { value: 'notCompleted', label: 'Page Not Completed' },
          { value: 'revenue', label: 'Revenue (beta)', aggregator: true },
          { value: 'rpi', label: <span>RPI $ (<small><i>Rev. / Impression</i></small>)</span>, aggregator: true },
          { value: 'rps', label: <span>RPS $ (<small><i>Rev. / Path Session</i></small>)</span>, aggregator: true },
          { value: 'rpu', label: <span>RPU $ (<small><i>Rev. / Uniq. Users</i></small>)</span>, aggregator: true },
          { value: 'optout', label: 'Is Optout' },
          { value: 'notOptout', label: 'Is Not Optout' },
        ],
      },
    },
    filterby: {
      options: [{
        value: 'path',
        get label() {
          return <formatters.Loadable isLoading={ImpressionStore.path.isLoading}>Path</formatters.Loadable>
        },
        options: ImpressionStore.path.fetchData,
      }, {
        value: 'page',
        get label() {
          return <formatters.Loadable isLoading={ImpressionStore.page.isLoading}>Page</formatters.Loadable>
        },
        options: ImpressionStore.page.fetchData,
      }, {
        value: 'publisher',
        get label() {
          return <formatters.Loadable isLoading={ImpressionStore.publisher.isLoading}>Publisher</formatters.Loadable>
        },
        options: ImpressionStore.publisher.fetchData,
      }, {
        value: 'allocation',
        get label() {
          return <formatters.Loadable isLoading={ImpressionStore.allocation.isLoading}>Allocation</formatters.Loadable>
        },
        options: ImpressionStore.allocation.fetchData,
      }, {
        value: 'pathUserProfile',
        get label() {
          return <formatters.Loadable isLoading={ImpressionStore.pathUserProfile.isLoading}>Path User Profile</formatters.Loadable>
        },
        options: ImpressionStore.pathUserProfile.fetchData,
      }],
    },
  }), [])

  return <PivotTable
    configure={configure}
    useLoad={useLoad}
    reportView={reportView}
    isLoading={loading}
    data={data}
    title="Impression Pivot Table"
  />
}

export default function Layout() {
  return <ImpressionPivotProvider>
    <ImpressionPivotTable />
  </ImpressionPivotProvider>
}
